/* eslint-disable no-unused-vars */
export enum PhoneType {
  Day = "day",
  Emergency = "emergency",
  Fax = "fax",
  Home = "home",
  Mobile = "mobile",
  Night = "night",
  Office = "office",
  Pager = "pager",
  None = "",
}
